export const LOGIN_ROUTE = "/";
export const LINK_EXPIRED_ROUTE = "/linkExpired";
export const CUSTOMER_PAYMENT = "/main/payment";
export const CUSTOMER_ONBOARDING_PAYMENT_ROUTE = "/paymentMethod";
export const CUSTOMER_ONBOARDING_PAYMENT_SUCCESS_ROUTE = "/paymentSuccess";
export const CUSTOMER_ONBOARDING_CALENDLY_MEETING_ROUTE = "/calendlyMeeting";
export const CUSTOMER_PAYROLL_FIRST_PAYMENT = "payroll/firstPayment";
export const CUSTOMER_PAYROLL = "/main/payroll";
export const CUSTOMER_PAYROLL_HISTORY = "/main/payroll?history=true";
export const CUSTOMER_PROFILE_ROUTE = "/main/profile";
export const EMPLOYEE_PROFILE_ROUTE = "/main/eprofile";
export const COMMUNITY_ROUTE = "/main/community";
export const SETTINGS_ROUTE = "/main/settings";
export const REFER_A_BUSINESS_ROUTE = "/main/referrals";
export const RESET_PASSWORD_ROUTE = "/reset-password";
export const FORGOT_PASSWORD_ROUTE = "/forgot-password";
export const ADD_CUSTOMER_INFO_ROUTE = "/add-customer-info";
export const RESEND_LINK_ROUTE = "/resend-link";
export const EMPLOYEE_ONBOARDING_LINK_EXPIRED_ROUTE = "/employee-onboarding/link-expired";
export const CUSTOMER_DETAILS_ROUTE = "/main/customer/:customerId";
export const CUSTOMER_PAYROLL_DETAILS_ROUTE = "/main/payroll/detail/:payrollId";
export const CUSTOMER_PAYMENT_ROUTE = "/main/payment";
export const EMPLOYEE_DETAILS_ROUTE = "/main/details/:employeeId";
export const TALENT_PROFILE_ROUTE = "/main/talent-network/:talentId";

export const SETTINGS_PATHS = {
  BASE: "/main/settings",
  MANAGE_USERS: "/main/settings/manage-users",
  TIME_OFF: "/main/settings/time-off",
  COMPANY_PROFILE: "/main/settings/company-profile",
  TIME_OFF_COUNTRY: "/main/settings/time-off/:countryName",
  TIME_OFF_POLICY: "/main/settings/time-off/:countryName/:policyType/:policyId",
};

export const TIME_OFF_ROUTES = {
  BASE: SETTINGS_PATHS.TIME_OFF,
  COUNTRIES: {
    PAKISTAN: `${SETTINGS_PATHS.TIME_OFF}/pakistan`,
    COSTA_RICA: `${SETTINGS_PATHS.TIME_OFF}/costa_rica`,
    PERU: `${SETTINGS_PATHS.TIME_OFF}/peru`,
  },
  COUNTRY_DETAIL: (countryKey) => `${SETTINGS_PATHS.TIME_OFF}/${countryKey}`,
  POLICY_DETAIL: (countryKey, policyType, policyId = "new") =>
    `${SETTINGS_PATHS.TIME_OFF}/${countryKey}/${policyType}/${policyId}`,
};
